// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/internal_user_groups/internal_user_groups_data_v2" endpoint
 */
import fetch from "@lib/fetch";
import { serializeQueryObjects } from "@lib/serializeQueryObjects";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";
import { appSettingsV2InternalUserGroupsInternalUserGroups } from "./constants";
import type {
  AppSettingsV2InternalUserGroupsInternalUserGroupsParams,
  AppSettingsV2InternalUserGroupsInternalUserGroupsResult,
} from "./types";

type Query = Record<string, string | number | boolean | string[] | Record<string, string | number | boolean>>;

const addFilter = (query: Query, filterName: string, filter: string | string[] | undefined): Query => {
  if (filter) {
    return { ...query, [filterName]: filter };
  }

  return query;
};

const addPropertyFilter = (query: Query, propertyData: string | string[] | undefined): Query => {
  if (propertyData === "user_event_log") {
    return addFilter(query, "property_data", "sdk_log");
  }

  return addFilter(query, "property_data", propertyData);
};

export const getDataTableAppSettingsV2InternalUserGroupsInternalUserGroups = reactQueryTableFetcherAdapter(
  appSettingsV2InternalUserGroupsInternalUserGroups,
  (
    signal: AbortSignal,
    { appGroupId, query, limit = 10, start = 0, sortdir }: AppSettingsV2InternalUserGroupsInternalUserGroupsParams
  ): Promise<AppSettingsV2InternalUserGroupsInternalUserGroupsResult> => {
    const { property_data: propertyData, "": name, ...otherQuery } = query;

    const updatedQuery = addFilter(addPropertyFilter(otherQuery, propertyData), "name", name);

    return fetch(
      "/internal_user_groups/internal_user_groups_data_v2",
      "GET",
      {
        limit,
        sortdir,
        start,
        app_group_id: appGroupId,
        query: serializeQueryObjects(updatedQuery),
      },
      { signal }
    );
  }
);
